<!-- Capture options dialog -->
<app-dialog [visible]="captureDialogVisible" [fullscreenOnMobile]="true" title="Capture an issue" class="max-w-[50rem]"
    (closed)="onCaptureDialogHide()">
    <ng-template #bodyTemplate>
        <div class="flex flex-row justify-between w-full gap-4 p-4">
            <div class="p-3 flex flex-col border border-gray-200 gap-2 cursor-pointer hover:bg-gray-50 transition-colors rounded-lg shadow-md w-[50%]"
                (click)="captureScreenshot()">
                <i [innerHTML]="SVG.CAPTURE_A_SCREENSHOT | sanitizeHtml"></i>
                <span class="text-md font-medium">Capture a screenshot</span>
                <span class="text-sm text-gray-600">
                    Take a quick snapshot of your screen to highlight an issue or share a specific moment.
                    <br>
                    Steps: select screen -> click share -> the screenshot is captured instantly when you click share.
                </span>
            </div>
            <div class="p-3 flex flex-col border border-gray-200 gap-2 cursor-pointer hover:bg-gray-50 transition-colors rounded-lg shadow-md w-[50%]"
                (click)="captureVideo()">
                <i [innerHTML]="SVG.CAPTURE_VIDEO | sanitizeHtml"></i>
                <span class="text-md font-medium">Capture a video</span>
                <span class="text-sm text-gray-600">
                    Record your screen to walk through an issue, explain a flow, or show steps in real time.
                    <br>
                    Steps: select screen -> click share -> click stop share to end the video.
                </span>
            </div>
        </div>
    </ng-template>
</app-dialog>

<!-- Screenshot processing dialog -->
<app-dialog [visible]="capturingScreenshotLoadingDialogVisible" [showCloseButton]="false" [closable]="false"
    [fullscreenOnMobile]="false" title="Capturing Screenshot" class="max-w-[36rem]">
    <ng-template #bodyTemplate>
        <div class="flex flex-col items-center justify-center text-center p-4">
            @if (lottieAnimationData) {
            <app-lottie-animation [animationData]="lottieAnimationData" width="18.75rem" height="18.75rem" [loop]="true"
                [autoplay]="true" />
            }
            <span class="text-sm font-light leading-relaxed break-words max-w-full">
                Your screenshot is being processed. Please stay on this screen until it's complete.
            </span>
        </div>
    </ng-template>
</app-dialog>

<!-- Video processing dialog -->
<app-dialog [visible]="capturingVideoLoadingDialogVisible" [showCloseButton]="false" [closable]="false"
    [fullscreenOnMobile]="false" title="Capturing Video" class="max-w-[36rem]">
    <ng-template #bodyTemplate>
        <div class="flex flex-col items-center justify-center text-center p-4">
            @if (lottieAnimationData) {
            <app-lottie-animation [animationData]="lottieAnimationData" width="18.75rem" height="18.75rem" [loop]="true"
                [autoplay]="true" />
            }
            <span class="text-sm font-light leading-relaxed break-words max-w-full">
                Your video recording is being processed. Please stay on this screen until it's complete.
            </span>
        </div>
    </ng-template>
</app-dialog>
